module.exports = __webpack_public_path__ + "static/media/usina3.0bd9efc0.jpg";